import { useAuth } from "../provider/AuthProvider";

const Header = () => {
  const { userName } = useAuth();
  const { isMJ, setIsMJ } = useAuth();

  return (
    <header>
      <span className="title">Gestion des fiches de personnages</span>
      {userName && (
        <div className="user-div">
          <span className="user">{userName}</span>
          <button className="bt" onClick={setIsMJ}>
            {isMJ ? "MJ" : "Joueur"}
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
